require("./bootstrap");

import Alpine from "alpinejs";

window.Alpine = Alpine;

Alpine.start();

// Calendário de datas em DD/MM/AAAA (P7). O flatpickr mostra a data no formato
// d/m/Y (altInput) mas submete Y-m-d, mantendo a compatibilidade com o backend.
// Se por algum motivo o script não carregar, os campos continuam com o
// calendário nativo (type="date"), evitando regressões.
import flatpickr from "flatpickr";
import { Portuguese } from "flatpickr/dist/l10n/pt.js";

function aplicarDatepicker() {
    document.querySelectorAll("input[data-datepicker]").forEach(function (el) {
        if (el._flatpickr) {
            return;
        }
        flatpickr(el, {
            locale: Portuguese,
            dateFormat: "Y-m-d",
            altInput: true,
            altFormat: "d/m/Y",
            allowInput: true,
        });
    });
}

document.addEventListener("DOMContentLoaded", aplicarDatepicker);
document.addEventListener("livewire:navigated", aplicarDatepicker);
document.addEventListener("livewire:update", aplicarDatepicker);
